import React from 'react';
import { Link } from '../../../env';

const PrevArrow = ({ class1, class2, status, onClick }) => {
    return (
        <div onClick={onClick} className={class1}>
            <img src={status ? `${Link}assets/Arrows/arrow.png` : `${Link}assets/Arrows/arrow-black.png`} alt='Next Arrow' className={`${class2} ${status ? '' : '-rotate-90'}`} />
        </div>
    );
}

export default PrevArrow;
